import { render, staticRenderFns } from "./CountryPopup.vue?vue&type=template&id=42ddf318&scoped=true&"
import script from "./CountryPopup.vue?vue&type=script&lang=js&"
export * from "./CountryPopup.vue?vue&type=script&lang=js&"
import style0 from "./CountryPopup.vue?vue&type=style&index=0&id=42ddf318&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ddf318",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
